"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorAttendingsListApiResponseSchema = exports.getDoctorAttendingListItemApiEntitySchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const office_1 = require("../offices/office");
const get_doctor_attending_1 = require("./get-doctor-attending");
exports.getDoctorAttendingListItemApiEntitySchema = get_doctor_attending_1.getDoctorAttendingApiEntitySchema.merge(zod_1.z.object({
    relationships: zod_1.z.object({
        office: (0, api_1.apiEntityRelationshipSchema)('offices'),
    }),
}));
exports.getDoctorAttendingsListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getDoctorAttendingListItemApiEntitySchema).merge(zod_1.z.object({
    included: zod_1.z.array(office_1.simpleOfficeApiSchema).optional().default([]),
}));
